/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

require('../../modules/es6.number.max-safe-integer');
module.exports = 0x1fffffffffffff;




//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/number/max-safe-integer.js
// module id = 1072
// module chunks = 60